// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Y59h","bigColWidth":"Table_bigColWidth__1n_EX","biggerColWidth":"Table_biggerColWidth__cYrU0","row":"Table_row__3xcUc","col":"Table_col__Ud1z9"};